import { RecipeCategory } from './RecipeCategory';
import { RecipeIngredient } from './RecipeIngredient';
import { Nutritions } from "./Nutritions";
import type { Subrecipe } from './Subrecipe';
import { CookingMethod } from './CookingMethod';
import { RecipeServingType } from './RecipeServingType';
import { LossType } from './LossType';
import { CaloriesCalculationMethod } from './CaloriesCalculationMethod';
import { DailyValueCalculationMethod } from './DailyValueCalculationMethod';
import { NutritionCountry } from '../NutritionLabels/NutritionCountry';
import { RecipeProductType } from './RecipeProductType';

export class Recipe {
  id: number = 0;
  name: string = "";
  description: string = "";
  instructions: string = "";
  dishRecipeCount: number | null = null;
  recipeCategory: RecipeCategory | null = {
    id: undefined,
    name: undefined
  };
  referenceAmount: number= 0;
  productTypeId: number = 0;
  recipeProductType: RecipeProductType;
  adjustedAddedSugarsValue: number | null = null;

  ingredients: RecipeIngredient[] = [];
  childRecipes: Subrecipe[] = [];

  recipeServingType: RecipeServingType = RecipeServingType.Servings;
  servingCount: number | null = 1;
  servingQuantityInUnitOfMeasurement: number | null;
  servingUnitOfMeasurement: string | null;
  servings: number = 1;

  cookingMethodId?: number | null;
  cookingMethod?: CookingMethod | null;

  lossType: number | null = null;
  lossAmount: LossType | null = null;
  yieldFactor: number = 1;

  weight: number = 0;
  weightPerServing: number = 0;
  rawWeight: number = 0;
  rawWeightPerServing: number = 0;

  rawVolume: number | null;
  volume: number | null;
  rawVolumePerServing: number | null;
  volumePerServing: number | null;
  nutritionCountry: NutritionCountry | null;

  quantityPerServingInUnitOfMeasurement: QuantityPerServingInUnitOfMeasurementTuple = {
    item1: 100, // quantity
    item2: 'g', // unit of measurement
  };

  nutritionAnalysis: Nutritions = new Nutritions(
    [],
    'g',
    0,
    0,
    0,
    0,
    0,
    null,
    null,
    null,
    null
  );

  caloriesCalculationMethod: CaloriesCalculationMethod = CaloriesCalculationMethod.Summation;
  dailyValueCalculationMethod: DailyValueCalculationMethod = DailyValueCalculationMethod.Rounded;
  proteinDvCalculationMethod: number = 0;
  pdcaasScore: number = 1;

  createdOn?: Date | null = null;
  updatedOn?: Date | null = null;
  createdUserName?: string | null = null;
  updatedUserName?: string | null = null;

  servingQuantityInUnitOfMeasurementOverride: number | null;
  servingUnitOfMeaurementOverride: string;

  constructor() {
    this.recipeProductType = {
      createdOn: null,
      id: 0,
      name: " ",
      productType: 0,
      countryId: 0
    };
  }
}

type QuantityPerServingInUnitOfMeasurementTuple = {
  item1: number; // quantity
  item2: string; // unit of measurement
};